module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightAlert2-bdcb0884de0edcb343a91b534bf3be94.jpg";